export const API_ENDPOINT = 'https://api.rtvhit.com';
